import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "../data/mock";

/**
 * Reusable per-route SEO helmet.
 * Renders unique <title>, meta description, canonical URL, and Open Graph tags.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = "/logo-518.png",
  jsonLd,
  noindex = false
}) {
  const site = "https://518courier.com";
  const canonical = `${site}${path}`;
  const fullTitle = title || `${COMPANY.name} — Reliable Courier Service in NY's Capital Region`;
  const desc =
    description ||
    `${COMPANY.name} provides same-day, medical, scheduled and interstate courier services across New York's Capital Region. Call ${COMPANY.phone}.`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${site}${image}`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={`${site}${image}`} />

      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
}
